import { WitnessModel } from '@neo-one/client-common';
export const witness = (witnessLike) => new WitnessModel({
    invocation: Buffer.from(witnessLike.invocation, 'hex'),
    verification: Buffer.from(witnessLike.verification, 'hex'),
});

//# sourceMappingURL=witness.js.map
